/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import courseraPlus from 'bundles/epic/data/defaults/courseraPlus.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  courseUpsellVariant: 0 | 1 | 2 | 3;
  welcome: 'control' | 'features' | 'carousel';
  isCollectionPagePendoEnabled: boolean;
  is39GatewaysTo49CourseraPlusUpsellEnabled: boolean;
  is39SpecializationTo49UpsellEnabled: boolean;
  hideS12nUpsellFromWesternEuropeVariant: boolean;
  isS12nUpsell49NoFreeTrialEnabled: boolean;
  subscriptionTiersLiteVariant: 'optOut' | 'control' | 'A' | 'B' | 'C';
  tiersEnrollmentFromStandaloneCoursesVariant: 'optOut' | 'control' | '3';
  idealUpgradeFullStoryEnabled: boolean;
  subscriptionTiersLiteLandingPageVariant: 'optOut' | '3';
  liteEnrollmentModalDesignTweaksVariant: 'optOut' | 'control' | '1' | '2' | '3' | '4' | '5';
  liteEnrollmentModalDesignTweaksVariantVersion2: 'optOut' | 'control' | '1' | '2' | '5';
  subscriptionTiersDesignV3Variant: 'optOut' | 'control' | '1' | '2' | '3' | '4' | '5';
  subscriptionTiersDesignV3RelaunchVariant: 'optOut' | 'control' | '3';
  subscriptionTiersPricingTestVariant: 'optOut' | '3';
  subscriptionTiersPricingTestVariantIndia: 'optOut' | '3';
  subscriptionTiersPricingVariantLowIncomeCountries: 'optOut' | '3';
  checkoutSubscriberCountAndPartnerLogo: 'control' | '1' | '2' | '3';
  isLearnerImpressedInIndiaTiersEpic: boolean;
  showWesOnCourseraPlusLandingPage: boolean;
  s12n49StripeUpsellVariant: 'optOut' | 'upsell_49_cplus';
  courseraPlusAnnualWith7dayFreeTrialTest: 'control' | '1' | '2' | '3';
  courseUpsellStripe: boolean;
  tiersFromStandaloneCoursesPartnerExclusionEnabled: boolean;
  plusMonthlyToAnnualUpgradeEnabledOnLIHP: boolean;
  isCourseraPlusPromoRedesignEnabled: boolean;
  s12nToCourseraPlusEmailFlowEnabled: boolean;
};

const NAMESPACE = 'courseraPlus';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([courseraPlus as $TSFixMe]);

const courseraPlusEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default courseraPlusEpicClient;
